import { props } from '../hard-token-integration-properties';
import { samples } from '../hard-token-integration-samples';
import { maxTokenCount } from '../max-token-count';

export class Controller {

    $onInit() {
        this.csv = tokens2csv(this.tokens, this.props);
    }

    get props() {
        return props[this.type][this.otpType];
    }

    get propKeys() {
        return this.props.map(prop => `hard_tokens.integrate.props.${prop.name}`);
    }

    get csvPlaceholder() {
        const csv = tokens2csv(samples[this.type][this.otpType], this.props);
        // multi-line placeholder hack. stackoverflow.com/a/8843665
        return ' '.repeat(1000) + csv.split('\n').join(' '.repeat(1000));
    }

    csvChanged() {
        const tokens = csv2tokens(this.csv, this.props);
        if (tokens.length > maxTokenCount) {
            tokens.length = maxTokenCount;
            this.csv = tokens2csv(tokens, this.props);
        }
        this.onChange({tokens});
    }
}

function csv2tokens(csv, props) {
    return csv.trim().split('\n')
        .map(line => line.trim().split(',').slice(0, props.length).map(s => s.trim())
            .reduce((acc, val, idx) => Object.assign(acc, {[props[idx].name]: val}), {}));
}

function tokens2csv(tokens, props) {
    const values = (token) => props.map((prop) => token[prop.name]);
    const nonEmpty = (line) => line.replace(/[\s,]*/, '');
    return tokens.map((token) => values(token).join(',')).filter(nonEmpty).join('\n');
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-importer-csv/hard-token-importer-csv.controller.js